import React from "react";

import styles from "./HighlightButton.module.css";

export default function HighlightButton({ onClick, children, disabled = false }) {
  return (
    <button className={[styles.highlightButton, disabled ? styles.disabled : ''].join(' ')} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export function SecondaryButton({ onClick, children, disabled = false }) {
  return (
    <button className={[styles.secondaryButton, disabled ? styles.disabled : ''].join(' ')} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}